import { Box, Container, Typography } from '@material-ui/core';
import { Check } from '@material-ui/icons';
import useLanguageStore from '@stores/languageStore';
import { useTranslation } from 'react-i18next';

const PeaceOfMindStrip = () => {
  const { t } = useTranslation();
  const { language } = useLanguageStore();
  const isRtl = language === 'he';

  const features = [
    { key: 'licenses', label: t('home.peaceOfMind.strip.licenses') },
    { key: 'chevraKadisha', label: t('home.peaceOfMind.strip.chevraKadisha') },
    { key: 'obituary', label: t('home.peaceOfMind.strip.obituary') },
  ];

  return (
    <Box
      className="bg-white relative z-20"
      style={{
        padding: '24px 0',
        boxShadow: '0px 4px 10px rgba(0,0,0,0.08)',
        borderBottom: '1px solid #f0f0f0',
      }}
    >
      <Container maxWidth="lg">
        <div
          className={`flex flex-col w-fit mx-auto md:w-full ${
            isRtl ? 'md:flex-row-reverse' : 'md:flex-row'
          } md:justify-center items-start md:items-center gap-4 md:gap-8`}
        >
          {features.map((feature) => (
            <div
              key={feature.key}
              className="flex items-center justify-start md:justify-center w-full md:w-auto md:flex-1"
            >
              {/* Wrapper for Content to align Icon + Text */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'row-reverse',
                }}
              >
                <Typography
                  variant="body1"
                  component="span"
                  style={{
                    fontWeight: 700,
                    fontSize: '1.1rem',
                    color: '#333',
                    marginLeft: isRtl ? '0' : '12px',
                    marginRight: isRtl ? '12px' : '0',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {feature.label}
                </Typography>

                {/* Custom Solid Gold Icon */}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#D4AF37',
                    borderRadius: '50%',
                    width: '28px',
                    height: '28px',
                    color: 'white',
                    flexShrink: 0,
                    boxShadow: '0 2px 4px rgba(212, 175, 55, 0.3)',
                  }}
                >
                  <Check style={{ fontSize: '18px', strokeWidth: 2 }} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </Box>
  );
};

export default PeaceOfMindStrip;
